export const fuelLevelOptions = [
  { label: "Empty", value: "Empty" },
  { label: "Quarter", value: "Quarter" },
  { label: "Half", value: "Half" },
  { label: "Three Quarters", value: "ThreeQuarter" },
  { label: "Full", value: "Full" },
];

export const allFuelLevelOptions = [
  { label: "Empty", value: "Empty", step: 0 },
  { label: "Eighth", value: "Eighth", step: 1 },
  { label: "Quarter", value: "Quarter", step: 2 },
  { label: "Three Eighths", value: "ThreeEighth", step: 3 },
  { label: "Half", value: "Half", step: 4 },
  { label: "Five Eighths", value: "FiveEighth", step: 5 },
  { label: "Three Quarters", value: "ThreeQuarter", step: 6 },
  { label: "Seven Eighths", value: "SevenEighth", step: 7 },
  { label: "Full", value: "Full", step: 8 },
];

export const exchangeReasons = [
  { label: "Customer Request", value: "CustomerRequest" },
  { label: "Maintenance Issue", value: "VehicleMalfunction" },
  { label: "Upgrade Request", value: "Upgrade" },
  { label: "Accident Damage", value: "AccidentDamage" },
  { label: "Other", value: "Other" },
];
